import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Videos.css'
import v11 from './../assest/images/projectss/videos/v11.mp4'
import v22 from './../assest/images/projectss/videos/v22.mp4'
export const Videos = () => {
  return (
    <div className='vid'>
<Container>
<div className='row'>
    <video src={v11} autoplay controls width="500px" height
    ="" style={{backgroundColor:"#fff",padding:"20px",marginBottom:"30px"}}></video>
</div>

<div className='row'>
    <video src={v22} autoplay controls width="500px" height
    ="" style={{backgroundColor:"#fff",padding:"20px",marginBottom:"30px"}}></video>
</div>
</Container>
    </div>
  )
}
